import IronPreference from './IronPreference';

export default IronPreference;
